import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-4">Kakobuy Polska</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Największa polska baza wiedzy o Kakobuy Spreadsheet. Znajdź najlepsze produkty, linki i poradniki zakupowe.
            </p>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-4">Zasoby</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Kakobuy Spreadsheet
                </a>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-poradnik" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Poradnik Kakobuy
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Produkty
                </a>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Strona główna
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-4">Kategorie</h4>
            <ul className="space-y-2">
              <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Buty</a></li>
              <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Koszulki</a></li>
              <li><a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Kurtki</a></li>
              <li><a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">Akcesoria</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-900 mb-4">Informacje</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-poradnik" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Czy Kakobuy jest bezpieczny?
                </Link>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-poradnik" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Jak korzystać z Kakobuy?
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  Kup teraz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Kakobuy Polska. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">
              Polityka prywatności
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">
              Regulamin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}